/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Sentbutton3Inputs */

const en_coinvestments_draftemail_sentbutton3 = /** @type {(inputs: Coinvestments_Draftemail_Sentbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Coinvestments_Draftemail_Sentbutton3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_sentbutton3 = /** @type {((inputs?: Coinvestments_Draftemail_Sentbutton3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Sentbutton3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_sentbutton3(inputs)
});
export { coinvestments_draftemail_sentbutton3 as "coInvestments_draftEmail_sentButton" }